import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

const PUBLIC_URL = "/total/image-translator" || "";

// Custom language detector for URL path segments
const urlPathDetector = {
  name: "urlPath",
  lookup() {
    const path = window.location.pathname;
    // Extract language from URL path like /total/fr/image-translator/ or /total/it/image-translator/
    const pathMatch = path.match(/\/total\/([a-z]{2})\/image-translator/);
    if (pathMatch && pathMatch[1]) {
      const detectedLang = pathMatch[1];
      // Validate that it's a supported language
      const supportedLanguages = [
        "en",
        "fr",
        "it",
        "es",
        "ar",
        "zh",
        "de",
        "ja",
        "ru",
        "uk",
      ];
      if (supportedLanguages.includes(detectedLang)) {
        console.log(`Detected language from URL: ${detectedLang}`);
        return detectedLang;
      }
    }
    return undefined;
  },
};

// Create a custom language detector that includes our URL path detector
const customLanguageDetector = new LanguageDetector();
customLanguageDetector.addDetector(urlPathDetector);

// Initialize i18next before adding the custom detector
i18n
  // Load translation using http -> see /public/locales
  .use(Backend)
  // Use our custom language detector instead of the default one
  .use(customLanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    fallbackLng: "en",
    load: "languageOnly",
    debug: process.env.NODE_ENV === "development",

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    // Detection options
    detection: {
      order: [
        "urlPath", // Custom URL path detector (highest priority)
        "querystring",
        "cookie",
        "localStorage",
        "sessionStorage",
        "navigator",
        "htmlTag",
      ],
      lookupQuerystring: "lng",
      lookupCookie: "i18next",
      lookupLocalStorage: "i18nextLng",

      // Cache user language
      caches: ["localStorage", "cookie"],
      cookieExpirationDate: new Date(Date.now() + 1000 * 60 * 60 * 24 * 30), // 30 days
    },

    backend: {
      loadPath: `${PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`,
    },
  });

export default i18n;
